export const MAX_REPO_NUM_FOR_FREE_DORA_DURING_ONBOARDING = 5;
